import { combineReducers } from 'redux';
import { loadingBarReducer } from 'react-redux-loading';
import auth from './auth';
import profile from './profile';
import hints from './hints';

export default combineReducers({
  auth,
  profile,
  hints,
  loadingBar: loadingBarReducer,
});
